import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { useDispatch, useSelector } from "react-redux";
import Select, { components } from "react-select";
import { getZoneList } from "../../../../services/MasterApiServices";
import { guid } from "rsuite/esm/internals/utils";

const ZoneOption = (props) => (
  <components.Option {...props}>
    <input
      type="checkbox"
      checked={props.isSelected}
      onChange={() => {}}
      className="me-2"
    />
    <label className="mb-0">{props.label}</label>
  </components.Option>
);

const SelectedCountValueContainer = ({ children, ...props }) => {
  const selected = props.getValue();
  const [, inputChild] = children;
  return (
    <components.ValueContainer {...props}>
      {selected.length > 0 ? (
        <span className="text-truncate">{selected.length} selected</span>
      ) : (
        !props.selectProps.inputValue && (
          <span className="text-muted">{props.selectProps.placeholder}</span>
        )
      )}
      {inputChild}
    </components.ValueContainer>
  );
};

function AddProductSection({ register, getValues, watch, setValue, errors, tabIndex }) {
  const { sectionList, taxList } = useSelector((state) => state.usersetting);
  const { branchsettings } = useSelector((state) => state.settings);
  const [toggleActiveAll, setToggleActiveAll] = useState(false);
const [bulkPrice, setBulkPrice] = useState("");
  const [zoneOptions, setZoneOptions] = useState([]);
  const [selectedZoneGuids, setSelectedZoneGuids] = useState([]);
  const [selectedZoneForApply, setSelectedZoneForApply] = useState(null);


  useEffect(() => {
  const fetchZones = async () => {
    try {
      const response = await getZoneList();
      setZoneOptions(response || []);
    } catch (error) {
      console.error("Failed to fetch zones:", error);
    }
  };

  fetchZones();
}, []);



  const columns = [
    {
      title: "Is Active",
      dataIndex: "",
      render: (_, value, index) => (
        <input
          type="checkbox"
          className=""
          {...register(`sectionWiseProductDetailList[${index}].IsActive`)}
        />
      ),
    },
{
  title: " Zone ",
  dataIndex: "",
  render: (_, value, index) => {
    const zoneName =
      zoneOptions.find((z) => z.guid === value.zoneGuID)?.name || "";

    return (
      <>
  <input
    type="hidden"
    {...register(`sectionWiseProductDetailList[${index}].zoneGuID`)}
  />
  <input
    type="text"
    className="form-control"
    value={zoneName}
    disabled
  />

      </>
    );
  },
}
,
    {
      title: "Section",
      dataIndex: "name",
      render: (_, value, index) => (
        <div>
          <select
            name=""
            id=""
            className="form-control"
            {...register(`sectionWiseProductDetailList[${index}].Section`)}
          >
            <option value={value.guid} key={value.id}>
              {value.name}
            </option>
          </select>
        </div>
      ),
    },
    {
      title: "Price",
      dataIndex: "",
      render: (_, val, index) => (
        <div>
          <input
            type="number"
            id={index === 0 ? "add-first-price-input" : undefined}
            className="form-control w-50"
            step="any"
            min={0}
            {...register(`sectionWiseProductDetailList[${index}].Price`)}
          />
        </div>
      ),
    },

    ...(branchsettings.disableTaxInSale == false
      ? [
          {
            title: "Tax",
            dataIndex: "",

            render: (_, value, index) => (
              <div>
                <select
                  name=""
                  id=""
                  className="form-control"
                  {...register(`sectionWiseProductDetailList[${index}].Tax`)}
                  value={watch().sectionWiseProductDetailList[index].Tax}
                  onChange={(e) => {
                    const selectedTax = e.target.value;
                    if (selectedTax === "") {
                      setValue(
                        `sectionWiseProductDetailList[${index}].Tax`,
                        ""
                      );

                      setValue(
                        `sectionWiseProductDetailList[${index}].IsTaxIncludedInPrice`,
                        false
                      );
                    } else
                      setValue(
                        `sectionWiseProductDetailList[${index}].Tax`,
                        e.target.value
                      );
                  }}
                >
                  <option value=""> select</option>
                  {taxList &&
                    taxList?.map((obj) => {
                      return (
                        <option value={obj.guid} key={obj.id}>
                          {obj.name}
                        </option>
                      );
                    })}
                </select>
              </div>
            ),
          },
          {
            title: "Tax Inclusive",
            dataIndex: "",
            render: (_, value, index) => {
              const taxSelected = watch(
                `sectionWiseProductDetailList[${index}].Tax`
              );
              return (
                <input
                  type="checkbox"
                  className=""
                  {...register(
                    `sectionWiseProductDetailList[${index}].IsTaxIncludedInPrice`
                  )}
                  // required={taxSelected}
                  disabled={!taxSelected} // Disable if no tax is selected
                />
              );
            },
          },
        ]
      : []),
  ];

const [selectedTaxGuid, setSelectedTaxGuid] = useState("");
const [isTaxIncluded, setIsTaxIncluded] = useState(false);

const handleApplyTaxToAll = () => {
  const list = watch("sectionWiseProductDetailList") || [];

  list.forEach((_, index) => {
    // Update Tax if selected
    if (selectedTaxGuid)
      setValue(`sectionWiseProductDetailList[${index}].Tax`, selectedTaxGuid);

    // Update Tax Inclusive if a tax is selected
    setValue(
      `sectionWiseProductDetailList[${index}].IsTaxIncludedInPrice`,
      selectedTaxGuid ? isTaxIncluded : false
    );

    // Update Active checkbox
    setValue(`sectionWiseProductDetailList[${index}].IsActive`, toggleActiveAll);

    // Update Price if entered
    if (bulkPrice !== "")
      setValue(`sectionWiseProductDetailList[${index}].Price`, parseFloat(bulkPrice));
  });
};
const handleApplyZone = () => {
  const list = watch("sectionWiseProductDetailList") || [];

  console.log("Selected Zone GUIDs:", selectedZoneGuids);
  console.log("Section List:", sectionList);

  list.forEach((_, index) => {
    const sectionZoneGuid = sectionList[index]?.zoneGuID;

    if (selectedZoneGuids.includes(sectionZoneGuid)) {
      setValue(`sectionWiseProductDetailList[${index}].IsActive`, true);
    } else {
      setValue(`sectionWiseProductDetailList[${index}].IsActive`, false);
    }
  });
};

// console.log("zoneOptions", zoneOptions);
// console.log("sectionList", sectionList);
useEffect(() => {
  const formList = getValues("sectionWiseProductDetailList") || [];

  sectionList.forEach((section, index) => {
    if (formList[index]) {
      setValue(`sectionWiseProductDetailList[${index}].zoneGuID`, section.zoneGuID);
    }
  });
}, [sectionList]);

useEffect(() => {
  if (tabIndex === 1) {
    setTimeout(() => {
      const input = document.getElementById("add-first-price-input");
      if (input) {
        input.focus();
        input.select();
      }
    }, 150);
  }
}, [tabIndex]);



  return (
    <div>
      {Object.keys(errors || {})
        .map((key) => errors[key]?.message)
        .find(Boolean) && (
        <span className="error text-danger text-sm">
          {Object.keys(errors || {})
            .map((key) => errors[key]?.message)
            .find(Boolean)}
        </span>
      )}

  <div className="modal-body custom-modal-body pb-0">
  <div className="d-flex flex-wrap align-items-center gap-4 mb-3">

    {/* Mark All Active */}
    <div className="form-check d-flex align-items-center gap-2 mb-0">
      <input
        className="form-check-input"
        type="checkbox"
        checked={toggleActiveAll}
       onChange={(e) => setToggleActiveAll(e.target.checked)}
      />
      <label className="form-check-label mb-0">Is Active</label>
    </div>
    {/* Price */}
    <div className="d-flex align-items-center gap-2">
      <label className="mb-0">Price:</label>
      <input
        type="number"
        className="form-control"
        placeholder="Enter Price"
        style={{ minWidth: "120px" }}
        onChange={(e) => setBulkPrice(e.target.value)}
      />
    </div>
    <div className="form-check d-flex align-items-center gap-2 mb-0">
      <label className="mb-0">Tax:</label>
      <select
        className="form-select"
        value={selectedTaxGuid}
        onChange={(e) => setSelectedTaxGuid(e.target.value)}
        style={{ minWidth: "150px" }}
      >
        <option value="">Select Tax</option>
        {taxList?.map((tax) => (
          <option value={tax.guid} key={tax.id}>{tax.name}</option>
        ))}
      </select>
    </div>

    {/* Apply Button */}
    <div>
      <button
        type="button"
        className="btn btn-warning fw-semibold"
        onClick={handleApplyTaxToAll}
      >
        Apply to All
      </button>
    </div>

    {/* Tax Inclusive */}
    <div className="form-check d-flex align-items-center gap-2 mb-0">
      <input
        type="checkbox"
        className="form-check-input"
        checked={isTaxIncluded}
        onChange={(e) => setIsTaxIncluded(e.target.checked)}
        disabled={!selectedTaxGuid}
      />
      <label className="form-check-label mb-0">Tax Inclusive</label>
    </div>
  </div>

  <div className="d-flex flex-wrap align-items-center gap-3">
    <div style={{ minWidth: "220px", maxWidth: "260px" }}>
      <Select
        isMulti
        closeMenuOnSelect={false}
        hideSelectedOptions={false}
        controlShouldRenderValue={false}
        options={zoneOptions.map((zone) => ({ value: zone.guid, label: zone.name }))}
        value={zoneOptions
          .filter((zone) => selectedZoneGuids.includes(zone.guid))
          .map((zone) => ({ value: zone.guid, label: zone.name }))}
        onChange={(selected) =>
          setSelectedZoneGuids((selected || []).map((s) => s.value))
        }
        components={{ Option: ZoneOption, ValueContainer: SelectedCountValueContainer }}
        classNamePrefix="react-select"
        placeholder="Select Zone(s)"
        styles={{
          control: (base) => ({ ...base, minHeight: 40, overflow: "hidden" }),
          valueContainer: (base) => ({ ...base, flexWrap: "nowrap", overflow: "hidden" }),
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        }}
        menuPortalTarget={document.body}
      />
    </div>

    <div>
      <button
        type="button"
        className="btn btn-warning fw-semibold me-3"
        onClick={handleApplyZone}
      >
        Apply
      </button>
      <button
  type="button"
  className="btn btn-cancel fw-semibold me-3"
  onClick={() => {
    const list = watch("sectionWiseProductDetailList") || [];
    list.forEach((_, index) => {
      setValue(`sectionWiseProductDetailList[${index}].IsActive`, false);
    });
    setSelectedZoneGuids([]); // Reset selected zones
  }}
>
  Reset
</button>
    </div>
  </div>
</div>


      <div className="table-responsive product-list mt-2">
        <Table columns={columns}
        dataSource={sectionList}
        pagination={false}
        rowKey="guid"
        size="small"
        />
      </div>
    </div>
  );
}

export default AddProductSection;
